export default __webpack_public_path__ + "static/media/companies.435c9404.jpg";